var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowUpRightWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22363 3.98592C4.23141 3.43369 4.68538 2.99232 5.23761 3.0001L11.92 3.09422C12.4612 3.10184 12.8982 3.53877 12.9058 4.08004L12.9999 10.7624C13.0077 11.3146 12.5663 11.7686 12.0141 11.7764C11.4619 11.7842 11.0079 11.3428 11.0001 10.7906L10.9393 6.4749L4.70711 12.7071C4.31658 13.0976 3.68342 13.0976 3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L9.5251 5.06069L5.20945 4.9999C4.65722 4.99212 4.21585 4.53815 4.22363 3.98592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpRightWhite);
export default __webpack_public_path__ + "static/media/ic-arrow-up-right-white.fd3a5c1f030c646dbf5fc4ac8a85a762.svg";
export { ForwardRef as ReactComponent };